import Avatar from '@seller-hermes/features/ui-v2/Avatar';
import DropdownMenu from '@seller-hermes/features/ui-v2/DropdownMenu';
import { cn } from '@seller-hermes/utils/cn';
import { ShieldCheck } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

type SecurityUserChipProps = {
  name?: string;
  email?: string;
  className?: string;
};

/**
 * Chip do usuário logado no rodapé do menu lateral. Ao clicar, abre um popover
 * com a opção "Segurança", que leva à página de segurança da conta
 * (/settings/security), onde o usuário gerencia o próprio MFA (2FA).
 */
export function SecurityUserChip({
  name,
  email,
  className,
}: SecurityUserChipProps) {
  const navigate = useNavigate();

  const displayName = name?.trim() || email || 'Minha conta';
  const initials = (name?.trim() || email || '?').charAt(0).toUpperCase();

  return (
    <DropdownMenu>
      <DropdownMenu.Trigger asChild>
        <button
          type="button"
          className={cn(
            'hover:bg-muted flex min-w-0 items-center gap-x-2 rounded-md p-2 text-left transition-colors',
            className,
          )}
        >
          <Avatar className="h-7 w-7 shrink-0">
            <Avatar.Fallback className="text-xs font-medium">
              {initials}
            </Avatar.Fallback>
          </Avatar>
          <div className="min-w-0 flex-1">
            <div className="text-foreground truncate text-xs font-medium">
              {displayName}
            </div>
            {email ? (
              <div className="text-muted-foreground truncate text-[10px]">
                {email}
              </div>
            ) : null}
          </div>
        </button>
      </DropdownMenu.Trigger>
      <DropdownMenu.Content align="start" side="top" className="min-w-[200px]">
        <DropdownMenu.Item onClick={() => navigate('/settings/security')}>
          <ShieldCheck className="h-4 w-4" />
          Segurança
        </DropdownMenu.Item>
      </DropdownMenu.Content>
    </DropdownMenu>
  );
}
